<script lang="ts">import { cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { isMobile, isNotificationsOpen, isPlayerChatOpen, loggedIn, stateDepositBonusOffers, stateSelfInfo, toSiteUrl } from "@infinitro/global";
import TopCard from "./top-card.svelte";
</script>

<a href={toSiteUrl('/casino/', $loggedIn) || 'javascript:void(0)'}>
	<div class="top-card-container">
		<TopCard
			backgroundColor="#0C101C"
			backgroundColor2="#0C101C"
			backgroundImage={cfgToThemeCdnPath('/top-section/small-top-left.png')}
			height="100%"
			width="100%"
		/>
		<div class="content-top-card">
			<div class="content-wrapper">
				<div class="card-title">
					<h2 class="card-section-title">
						{$t(Verbiage.casino).toUpperCase()}
					</h2>
				</div>
				<div class="description-text">
					<p
						class="card-section-body"
						class:card-section-body-wider={$isPlayerChatOpen || $isNotificationsOpen}
					>
						<span>{$t(Verbiage.casino_subtitle)}</span>
					</p>
				</div>
			</div>
		</div>
	</div>
</a>

<style>
	a {
		height: 100%;
		width: 100%;
}

	.content-top-card {
		position: absolute;
		z-index: 50;
		display: flex;
		height: 100%;
		width: 100%;
		align-items: center;
		justify-content: space-between;
		padding: 1rem;
}

	.content-wrapper {
		display: flex;
		height: 100%;
		width: 100%;
		flex-direction: column;
		justify-content: space-between;
}

	.top-card-container {
		position: relative;
		display: flex;
		height: 100%;
		width: 100%;
		cursor: pointer;
		align-items: center;
		justify-content: space-between;
}

	.text-with-shadow {
		text-shadow: 0px 0px 2px rgba(0, 0, 0, 1);
	}

	.card-title {
		display: flex;
		width: 100%;
		justify-content: flex-start;
}

	.description-text {
		width: 60%;
}

	.card-section-title {
		font-size: 14px;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family: var(--font-alternative-2);
		font-weight: 700;
}

	.card-section-body {
		max-width: 90%;
		font-size: 9px;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family: var(--font-alternative-2);
		text-align: start !important;
}

	.img-desktop {
		display: block;
}

	.img-tablet {
		display: none;
}

	/* ----------------------- SM ----------------------- */
	@media (min-width: 640px) {
		.hide-tablet {
				display: none;
		}

		.description-text {
				width: 100%;
		}

		.card-section-title {
				font-size: 24px;
		}

		.card-section-body {
				max-width: 40%;
				font-size: 12px;
			font-size: clamp(8px, 0.8cqi, 12px) !important;
		}

		.img-desktop {
				display: none;
		}

		.img-tablet {
				display: block;
		}
	}

	/* ----------------------- XL ----------------------- */
	@media (min-width: 1280px) {
		a {
				width: 54%;
		}

		.content-top-card {
				align-items: center;
				justify-content: space-between;
				padding: 0.75rem;
		}

		.top-card-container img {
				top: -18%;
				height: 120%;
		}

		.hide-tablet {
				display: flex;
		}

		.card-title {
				justify-content: flex-start;
		}

		.card-section-title {
				font-size: 18px;
			font-size: clamp(8px, 1.1cqi, 18px) !important;
		}

		.img-desktop {
				display: block;
		}

		.img-tablet {
				display: none;
		}
	}

	/* ------------------ Custom 1440 ------------------ */
	@media (min-width: 1440px) {
		.content-top-card {
				padding: 1.25rem;
		}
	}

	@media (min-width: 1600px) {
		.card-section-body {
				font-size: 14px;
		}
	}
</style>
